import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Drawer, Icon, notification } from "antd";
import axios from "axios";

import Estudo from "../EstabelecimentosEstudo/EstudoRestantes";
import DrawerEstudo from "../Drawers/DrawerEstudo";
import ModalEstudo from "../../components/modals/ModalPlanoAtendimento";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const EstudosRestantes = () => {
    const [estudos, setEstudos] = useState([]);
    const [estudoId, setEstudoId] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <>
                    <Link
                        to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                        className="botao-secundario botao-secundario-redondo"
                        onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                        style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                        <Icon type="arrow-left" />
                    </Link>
                </>
            );
        }
    };

    const handleEditarEstudo = id => {
        setDrawerVisible(true);
        setEstudoId(id);
    };

    const handleViewEstudo = id => {
        setModalVisible(true);
        setEstudoId(id);
    };

    const handleCloseDrawer = () => {
        setDrawerVisible(false);
        setEstudoId(null);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setEstudoId(null);
    };

    const carregarEstudos = () => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/atendimento/carregar-planos-atendimento",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                tipo: "estudo_caso_diagnostico"
            }
        })
            .then(response => {
                setEstudos(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao carregar os estudos de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const atualizarListagem = () => {
        setDrawerVisible(false);
        setEstudoId(null);
        carregarEstudos();
    };

    const handleDelete = () => {
        setModalVisible(false);
        setEstudoId(null);
        carregarEstudos();
    };

    useEffect(() => {
        carregarEstudos();
    }, []);

    return (
        <>
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="controlos controlos-fundo ">
                        <div className="bloco-esquerda">
                            <span className="titulo-pagina">Estudos de caso</span>
                        </div>
                        <div className="bloco-direita">
                            <Link
                                to="#"
                                className="botao-principal botao-principal-redondo"
                                title="Novo atendimento"
                                onClick={() => setDrawerVisible(true)}
                            >
                                +
                            </Link>
                            {montarBotaoVoltar()}
                        </div>
                    </div>
                    <div className="bloco">
                        <div className="bloco-atendimentos">
                            <div className="titulo-bloco-atendimentos">Estudos criados</div>
                            <div className="lista-planos-atendimentos">
                                {estudos.length === 0 &&
                                    'Nenhum estudo criado ainda. Clique no botão " + " para criar seu primeiro estudo.'}
                                {estudos.map(estudo => (
                                    <React.Fragment key={estudo.id}>
                                        <Estudo onEdit={handleEditarEstudo} onView={handleViewEstudo} estudo={estudo} />
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DrawerEstudo id={estudoId} visible={drawerVisible} onClose={handleCloseDrawer} atualizarListagem={atualizarListagem} />
            <ModalEstudo id={estudoId} visible={modalVisible} onCancel={handleCloseModal} onDelete={handleDelete} />
        </>
    );
};

export default EstudosRestantes;
